import { useIntl } from 'react-intl';

import React from 'react';
import { Colours, ColourItem, ColourList } from './styles';

interface Props {
  colours: Record<string, any>[];
  selectedColour?: string;
  onColourChange?: (args) => void;
  colourSelectable?: boolean;
}

const ColourPicker = ({
  colours,
  selectedColour,
  onColourChange,
  colourSelectable = false,
}: Props) => {
  const intl = useIntl();
  const isWhite = (hexValue) => hexValue && hexValue.toUpperCase() === 'FFFFFF';

  // If colours are clickable

  if (colourSelectable) {
    return (
      <Colours className="selectable">
        {colours
          && colours.map(({ hexValue, displayName, assetUrl }) => hexValue || assetUrl ? (
            <ColourItem
              data-testid={`colorItem-${displayName}`}
              key={`${hexValue}-${displayName}`}
              colour={hexValue}
              imageUrl={assetUrl}
              name={displayName}
              alt={displayName}
              title={displayName}
              className={isWhite(hexValue) ? 'white' : ''}
              selected={selectedColour}
              onClick={onColourChange ? () => onColourChange(displayName) : undefined}
            />
          ) : (
            <ColourItem
              className="default"
              name={displayName}
              selected={selectedColour}
              title={intl.formatMessage({ id: 'NoColour' })}
              onClick={onColourChange ? () => onColourChange(displayName) : undefined}
              alt={displayName}
              data-testid={`colorItem-${displayName}`}
            />
          ))}
      </Colours>
    );
  }

  return (
    // Else if colours are preview only (like in phone component)
    <Colours>
      {colours
        && colours.map(({ hexValue, displayName }) => (
          <ColourList
            key={`${hexValue}-${displayName}`}
            colour={hexValue}
            name={displayName}
            alt={displayName}
            title={displayName}
            className={isWhite(hexValue) ? 'white' : ''}
            colourSelectable={colourSelectable}
          />
        ))}
    </Colours>
  );
};

export default ColourPicker;
